import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0
  },
  chip: {
    margin: theme.spacing(0.5)
  },
  list: {
    listStyle: 'none'
  }
}))

const ChipsList = ({ filters, onChipDelete, isDisabled=false, readOnly }) => {
  const classes = useStyles()
  const handleDelete = (chip) => {

    onChipDelete(chip)
  }

  const transformFilters = () => {
    if (!filters) {
      return []
    }

    // Se eliminan los campos que no son necesarios para los filtros
    delete filters.fields
    delete filters.nuevo
    delete filters.page
    delete filters.per_page
    delete filters.tab
    delete filters.isManagement
    delete filters.sort

    const entriesList = Object.entries(filters)
    //paso los objetos a array y armo la estructura
    const chips = []
    entriesList.forEach(item => {
      const itemsValue = item[1]
      const name = item[0]
      
      // Si no tiene valor, salta el paso
      if (!itemsValue) {
        return;
      }

      // Cuando es un array, recorro el mismo y creo los chips
      if (Array.isArray(itemsValue)) { 
        itemsValue.forEach(element => {
          const { value, label, readOnly: elementReadOnly, nameId, disabled } = element
          chips.push({ value, label, name, readOnly: elementReadOnly, nameId, disabled})
        })
        return
      }

      let deconstructItems = { name: name }
      if (typeof itemsValue === 'object') {
        const { value, label, nameId, readOnly: itemReadOnly } = itemsValue //type select
        deconstructItems.value = value
        deconstructItems.label = label
        deconstructItems.nameId = nameId
        deconstructItems.readOnly = itemReadOnly
      } else if (typeof itemsValue === 'string' || typeof itemsValue === 'number') {
        //type text,number,etc
        deconstructItems.value = itemsValue
        deconstructItems.label = itemsValue
      }
      chips.push(deconstructItems)
    })

    return chips;
  }

  const chipsData = transformFilters()

  const renderChips = () => {
    return chipsData.map((chip, key) => {
      return (
        chip && (
          <li key={key} className={classes.list}>
            <Chip
              size="small"
              label={chip.label}
              onDelete={!chip.readOnly && !readOnly ? () => handleDelete(chip) : null}
              className={classes.chip}
              disabled={isDisabled || chip?.disabled}
              variant={isDisabled || chip?.disabled === true ? 'outlined' : 'default'}
            />
          </li>
        )
      )
    })
  }

  return (
    <>
      {chipsData && chipsData.length > 0 && (
        <ul className={classes.root}>
          {renderChips()}
        </ul>
      )}
    </>
  )
}

export default ChipsList